import { createUrlWithInternalMockUrlParams } from "../../../utils/internal-mock-url-params.js";
const DEALS_ENTRY_POINT_PATH = "/deals";
export function getDealsEntryPointUrl(currentSearch) {
    return createUrlWithInternalMockUrlParams(DEALS_ENTRY_POINT_PATH, currentSearch);
}
